import { render, staticRenderFns } from "./PenerimaanEdit.vue?vue&type=template&id=d033b2e6"
import script from "./PenerimaanEdit.vue?vue&type=script&lang=js"
export * from "./PenerimaanEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports